import { useContext } from 'react'

import { context } from '@Domains/Club/Context'

export function useClub() {
  return useContext(context)
}
